import { useAppSelector } from "@store";
import { getPresetFeature } from "@store/subscription/selectors";
import { openProDialog, openStarterDialog, openTeamDialog } from "@/shared";

const useLockedAction = ({ feature }: { feature: string }) => {
  const { value, plan } = useAppSelector(
    getPresetFeature<string | number | boolean>(feature),
  );

  const onLockedAction = () => {
    if (value === null) return;
    const mapping: Record<string, () => void> = {
      starter: () => openStarterDialog(feature),
      pro: () => openProDialog(feature),
      team: () => openTeamDialog(feature),
    };

    mapping[plan as keyof typeof mapping]();
  };

  return {
    onLockedAction,
    isLocked: value !== null,
    value,
    plan,
  };
};

export default useLockedAction;
